"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
const ContentPlaceholder = ({
  count = 1,
  className,
  height = null,
  width = null,
  radius = 3,
  style
}) => _react.default.createElement(_styles.ContentPlaceholderBox, {
  className: className
}, Array.from(Array(count)).map((_, idx) => _react.default.createElement(_styles.Placeholder, {
  key: idx,
  style: {
    height,
    width,
    borderRadius: radius,
    ...style
  }
}, "\u200C")));
var _default = exports.default = ContentPlaceholder;